import React, { Children } from 'react';
import PropTypes from 'prop-types';
import { Grid } from '@mui/material';

export default function SocialLinksGrid({ children }) {
  const items = Children.toArray(children);

  return (
    <Grid container spacing={0}>
      <Grid size={12}>{items[0]}</Grid>
      <Grid size={12}>{items[1]}</Grid>
      <Grid size={12}>{items[2]}</Grid>
      <Grid size={12}>{items[3]}</Grid>
    </Grid>
  );
}

SocialLinksGrid.propTypes = {
  children: PropTypes.node,
};
